const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Workflows Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('WorkflowResults', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/workflows/results/:workflowid', null, {
    get: {params: {workflowid: ''}, method: 'GET', isArray: true},
  });
}]);